import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import langMixin from "@/mixins/langMixin";

const app = createApp(App);

window.setLanguage = function (lang) {
    if (['en', 'de', 'es', 'pt', 'fr', 'it', 'tr', 'ja', 'pl', 'ar'].includes(lang)) {
        store.commit('updateLanguage', lang)
    }
};

window.fetchServer = async function(endpoint, data = {}) {
    const headers = {
        'Content-Type': 'application/json'
    }

    const sessionHash = localStorage.getItem('hash')
    if(sessionHash !== null) {
        headers['Authorization'] = `Bearer ${sessionHash}`
    }

    const response = await fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        signal: AbortSignal.timeout(10000),
        headers
    })

    if(!response.ok) {
        throw new Error('Server respond with status code '+response.status+` (${response.statusText})`)
    }

    return await response.json()
}

app.config.globalProperties.setLanguage = window.setLanguage

app.mixin(langMixin)
app.use(store).use(router).mount('#app')

